export default "__VITE_ASSET__DiPpmedQ__"